import ContainerRoutes from "../quality_control/container";
import CropFieldRoutes from "../quality_control/crop_field";

export default [
    ...ContainerRoutes,
    ...CropFieldRoutes
]
